<template>
  <div class="mno_packet_items">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="select">
        <fg-input
            type="text"
            v-model="filter.mno_name"
            :placeholder="translate('traffic_packet_list.mno_packet_item.mno_name')"
            :label="translate('traffic_packet_list.mno_packet_item.mno_name')"
            @input="change_input"
            :clearable="true"
        />
      </div>

      <div class="select">
        <label> {{ translate('traffic_packet_list.mno_packet_item.date') }} </label>
        <tree-select
            :options="date_list"
            :multiple="false"
            v-model="filter.date"
            :placeholder="translate('traffic_packet_list.mno_packet_item.date')"
            :clearable="true"
            :searchable="true"
            @input="change_input"
        />
      </div>

      <div class="select">
        <fg-input
            type="text"
            v-model="filter.iccid"
            :placeholder="translate('traffic_packet_list.mno_packet_item.iccid')"
            :label="translate('traffic_packet_list.mno_packet_item.iccid')"
            @input="change_input"
            :clearable="true"
        />
      </div>

      <div class="filter checkbox">
        <div class="info">
          {{ translate('traffic_packet_list.mno_packet_item.active') }}
        </div>
        <label class="switch" @click.prevent="filter.active = !filter.active">
          <input type="checkbox" v-model="filter.active">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.mno_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.mno_base_packet_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.traffic') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.iccid') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.date') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.period_start') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.period_end') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.status') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.ts_create') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.ts_update') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in items" :key="key" @click="show_info(item.id)"
            :class="{ active_item: item.status > 0 }">
          <td :data-label="translate('traffic_packet_list.mno_packet_item.mno_name')">
            {{ item.mno_name }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.mno_base_packet_name')">
            <router-link :to="{ path: '/mno_base_packets/' + item.mno_base_packet_id }">
              {{ item.mno_base_packet_name }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.traffic')">
            {{ item.traffic }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.iccid')">
            <router-link :to="{ path: '/simcard_profile/' + item.imsi }">
              {{ item.iccid }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.date')">
            {{ item.date }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.period_start')">
            {{ item.period_start }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.period_end')">
            {{ item.period_end }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.status')">
            {{ item.status > 0 ? 'Активен' : 'Неактивен' }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.ts_create')">
            {{ get_date(item.ts_create) }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.ts_update')">
            {{ get_date(item.ts_update) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>

<script>

import MnoPacketItem from "./MnoPacketItem.vue";

export default {
  name: 'MnoPacketItems',
  components: {
    MnoPacketItem
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data() {
    return {
      load: true,
      items: {},
      filter: {
        mno_name: "",
        date: null,
        iccid: "",
        active: true,
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    date_list() {
      let today = new Date().setHours(0, 0, 0, 0)
      let list = []
      for (let i = 0; i < 12; i++) {
        let date = new Date(today).setMonth(new Date(today).getMonth() - i)
        let string = new Date(date).getFullYear() + "-" + ("0" + (new Date(date).getMonth() + 1)).slice(-2)
        list.push({id: string, label: string})
      }
      return list
    },
  },

  created() {
    this.filter.date = this.date_list[0].id
    this.get_mno_packet_items()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_mno_packet_items, 500)
    },
    get_mno_packet_items() {
      let { mno_name, date, iccid, ...rest } = this.filter;

      let filter = { ...rest };
      if (mno_name !== "") filter.mno_name = mno_name;
      if (iccid !== "") filter.iccid = iccid;
      if (date !== "") filter.date = date;

      this.$http.v1.getMnoPacketItems(filter, (response) => {
        this.items = response.data
      })
    },
    show_info(mno_packet_item_id) {
      if (!mno_packet_item_id) return
      let t = this.$createElement(MnoPacketItem, {
        props: {
          mno_packet_item_id
        },
        on: {
          close: () => {
            this.$modal.hide('mno_packet_item')
            this.check_link = true
          },
          update: () => {
            this.$emit("update", this.send_filter)
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800, //TODO in const to
        adaptive: true,
        clickToClose: true,
        name: 'mno_packet_item'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },
}
</script>
<style lang='scss' scoped>
.mno_packet_items {
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex: 1;

    .select {
      width: 25%;
    }

    .checkboxs {
      width: 25%;
      display: flex;
      align-content: center;
      justify-content: space-between;

      .checkbox {
        width: 25%;
        margin: 0;
        min-width: auto;
      }
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    & > * {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .response_table{
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    flex: 10;
  }
}

table {
  .active_item {
    background-color: #41b88330;
  }
}
</style>
